<template>
  <div class="life_gxy_page">
    <div class="page_top_img_container life_bk_block">
      <img :src="pro=='gxy'?require('@/assets/images/life/banner5.png'):require('@/assets/images/life/banner4.png')" class="top_banner">
      <div class="page_content_container">
        <div class="title_with_line">
          <div class="title_line"><span>健康生活</span></div>
          <div class="title_e">Intelligence Life</div>
        </div>
        <div class="content_container margin_top_set">
          <div class="mmc_title_with_line">{{pro=='gxy'?'高血压百科':'糖尿病百科'}}</div>
          <el-button round size="mini" type="primary" @click="contentDistribution=true">内容发布</el-button>
        </div>
        <div class="article_list_show" v-for="(item,index) in pro=='gxy'?gdataList:tdataList" :key="index" @click="$router.push(item.targetUrl)">
          <div class="left_img" :style="{'background':'url('+item.imgUrl+') no-repeat center','background-size':'auto 100%'}"></div>
          <div class="right_text"><p class="title">{{item.title}}</p><p class="desc">{{item.desc}}</p></div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="contentDistribution" :show-close="false" class="contentDistributionDialog">
      <el-form :model="contentForm" label-position="left">
        <el-form-item label="标题栏目：">
          <el-input v-model="contentForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容描述：">
          <el-input type="textarea" v-model="contentForm.content" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="图片上传：">
          <el-upload action="#" list-type="picture-card" :auto-upload="false">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
            <img :src="file.url" alt="">
          </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="附件上传：">
          <el-upload action="#" list-type="picture-card" :auto-upload="false">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
            <img :src="file.url" alt="">
          </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button round @click="contentDistribution = false">取消</el-button>
        <el-button round type="primary" @click="$router.push('/login')">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      pro:this.$route.query.pro,
      gdataList:[
        {id:1,targetUrl:'gq1',imgUrl:require('@/assets/images/life/g_q1.jpeg'),title:'高血压认识十五个误区',desc:'思想决定行为。如果一个高血压患者对高血压的了解有偏差，那么多半就会做个“不合格的患者”，而为患者纠错，自然也是医生的一份责任。那么患者脑中的错误想法都有哪些？'},
        {id:5,targetUrl:'gq5',imgUrl:require('@/assets/images/life/g_q5.jpeg'),title:'高血压治疗十大误区',desc:'高血压是个终身性疾病，需要终身用药控制，但在高血压的治疗中仍然存在不少误区，这些错误你犯了吗？高血压的发生，与遗传和不健康的生活方式有关。控制高血压，除药物治疗外，还应该改善生活方式，但药物治疗无疑是主要措施。'},
        {id:3,targetUrl:'gq3',imgUrl:require('@/assets/images/life/g_q3.jpeg'),title:'生活中易诱发心脏病的十个小事',desc:'在一项为期11年的跟踪调查中，研究人员发现，与没有睡眠问题的人相比，几乎每天都睡不好觉的人心脏病危险增加45%，入睡困难的人心脏病危险增加30%，睡醒后感觉身体没有恢复的人心脏病危险增加27%。'},
        {id:4,targetUrl:'gq4',imgUrl:require('@/assets/images/life/g_q4.jpeg'),title:'“生命简单七法”让血压更平稳',desc:'血压波动大，就会损害血管内皮，那么有没有办法改善血压的波动？河北开滦总医院吴寿岭等进行的研究发现，生命简单七法（Life’s Simple 7），有助于改善24小时收缩压波动（即血压变异性），尤其是夜间的血压波动。“Life’s Simple 7”是指通过7项指标改善饮食和生活习惯从而达到理想心血管健康。'},
        {id:2,targetUrl:'gq2',imgUrl:require('@/assets/images/life/g_bk2/img1.jpg'),title:'绝大多数患者不了解家庭自测血压的正常值',desc:'北京大学人民医院孙宁玲教授在我国进行了一项家庭血压调查项目，结果显示：医生和患者对家庭自测血压诊断高血压标准的知晓率都较低。而且，尽管有85%的高血压患者知道在家自测血压，但选用的血压计、测量和记录时间还存在问题。'},
      ],
      tdataList:[
        {id:1,targetUrl:'tq1',imgUrl:require('@/assets/images/life/t_q1.jpeg'),title:'什么是糖尿病',desc:'糖尿病（diabetes mellitus，DM）是由于不同原因引起胰岛素分泌缺陷和（或）胰岛素作用缺陷导致糖、蛋白质、脂肪代谢异常，以慢性高血糖为突出表现的疾病。临床表现为多尿、多饮、多食、消瘦，可并发眼、肾、神经、心脏、血管等组织的慢性损伤，病情严重时可发生急性代谢紊乱，如酮症酸中毒、高渗性昏迷等。'},
        {id:2,targetUrl:'tq2',imgUrl:require('@/assets/images/life/t_q2.jpeg'),title:'这才是糖尿病真正的危害',desc:'2003年，全球糖尿病患者为1.94亿,预计2025年将达到3.33亿,目前我国糖尿病患者人数约 4千万左右，预计到2015年我国糖尿病患者将突破6千万左右。糖尿病可引起严重的并发症，包括急性并发症，如糖尿病酮症酸中毒、糖尿病非酮症高渗透性昏迷、乳酸酸中毒；慢性病发症，如糖尿病肾脏病变、糖尿病神经病变、糖……'},
        {id:5,targetUrl:'tq5',imgUrl:require('@/assets/images/life/t_q5.jpeg'),title:'三类降糖药物的合理运用',desc:'肥胖或超重的2型糖尿病，伴胰岛素抵抗的患者，用饮食和运动疗法效果不理想者；单用磺脲类药血糖控制不佳的2型糖尿病，可联合双胍类药物。'},
        {id:3,targetUrl:'tq3',imgUrl:require('@/assets/images/life/t_q3.jpeg'),title:'饭、菜、肉，先吃后吃有讲究！饮食细节决定血糖控制',desc:'吃，对于糖尿病患者来说是非常重要的环节。但许多糖尿病患者会发现，为什么我的饮食已经非常科学均衡了，却还是达不到想要的稳定血糖或者是降糖的目呢？'},
        {id:4,targetUrl:'tq4',imgUrl:require('@/assets/images/life/t_q4.jpeg'),title:'五只手指测血糖全都不一样？别担心，听听医生怎么说。',desc:'自我血糖监测，作为糖尿病综合管理的“五驾马车”之一，能够及时显示糖友的血糖数据，帮助糖友和临床医护人员了解其血糖波动情况，以调整治疗、饮食和运动方案，从而预防和延缓并发症的发生。'},
      ],
      contentDistribution:false,//内容发布弹框
      contentForm:{
        title:'',
        content:''
      }
    }
  }
}
</script>

<style lang="less">
.life_gxy_page{
  .content_container{
    .mmc_title_with_line{
      color: #0093dd;
    }
  }
  .contentDistributionDialog{
    .el-dialog{
      width: 95%;
      max-width: 563px;
      padding: 14px 24px 44px 36px;
      .el-dialog__header{
        display: none;
      }
      .el-dialog__body{
        box-sizing: border-box;
        .el-form-item{
          margin-bottom: 0px;
          .el-form-item__label{
            font-size: 18px;
            float: none;
          }
          .el-input__inner,.el-textarea__inner{
            font-size: 18px;
          }
          .el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 78px;
          }
        }
      }
      .el-dialog__footer{
        text-align: center;
        .el-button{
          font-size: 16px;
          height: 35px;
          line-height: 35px;
          width: 40%;
          padding: 0;
          &.el-button--default{
            color: #fff;
            background-color: #a0a0a0;
          }
        }
      }
    }
  }
}
</style>